import * as Application from 'expo-application';
import Constants from 'expo-constants';
import * as Device from 'expo-device';

/**
 * Returns whether app is running in Simulator (Expo Go or Dev Client).
 */
export function checkIfDeviceNotSimulator() {
  const isDeviceNotSimulator = Device.isDevice;

  return isDeviceNotSimulator;
}

/**
 * Returns whether app is running in Expo Go client.
 * Can be useful for conditional native modules' integration.
 */
export function checkIfInExpoGoClient() {
  return Constants.appOwnership === 'expo';
}

/**
 * Returns the current application version from the Expo app config
 */
export function getAppVersion() {
  return Constants.expoConfig?.version ?? '0.0.0';
}

/**
 * Returns the current build number from the native Info.plist
 */
export function getBuildNumber() {
  return Application.nativeBuildVersion ?? '0.0.0';
}
